import script from "./MaterialCalendarRange.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialCalendarRange.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialCalendarRange.vue?vue&type=style&index=0&id=389878b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389878b6"]])

export default __exports__